import React, { useContext, useState } from "react";
import {
  getBirthdayInFormat,
  getDate,
  getMonths,
  getYears,
  simplyClick,
  validateAge,
} from "../../helpers";
import ButtonSubmit from "../ButtonSubmit";
import "./BirthdayForm.scss";
import { errorEventsBirthday } from "../../constants";
import { ContextProfileUser } from "../../lib/profileContext";

function BirthdayForm({ nextStep }) {
  const [errorDate, setErrorDate] = useState(null);
  const { data, setData } = useContext(ContextProfileUser);

  const handlerSubmit = (e) => {
    e.preventDefault();

    const { error, status } = validateAge(data.month, data.day, data.year);

    const dateKey = [
      data.month ? "M" : "",
      data.day ? "D" : "",
      data.year ? "Y" : "",
    ].join("");

    if (!data.month && !data.day && !data.year) {
      setErrorDate("Please select your date of birth");
      simplyClick("err_lnd_age_nodate");
      return;
    }
    if (errorEventsBirthday[dateKey]) {
      setErrorDate(error || null);
      simplyClick(errorEventsBirthday[dateKey]);
      return;
    }
    if (!status) {
      setErrorDate(error);
      return;
    }

    const birthdayFormatted = getBirthdayInFormat(
      data.year,
      data.month,
      data.day
    );

    setData((prev) => ({ ...prev, birthday: birthdayFormatted }));
    simplyClick("cl_lnd_lt2_date_birth_next", { birthday: birthdayFormatted });
    nextStep();
  };

  const handleAddMonth = (e) => {
    const value = e.target.value;
    setData((prev) => ({ ...prev, month: value }));
    setErrorDate(null);
    simplyClick("cl_lnd_lt2_date_birth_month_choose");
  };

  const handleAddDay = (e) => {
    const value = e.target.value;
    setData((prev) => ({ ...prev, day: value }));
    setErrorDate(null);
    simplyClick("cl_lnd_lt2_date_birth_day_choose");
  };

  const handleAddYear = (e) => {
    const value = e.target.value;
    setData((prev) => ({ ...prev, year: value }));
    setErrorDate(null);
    simplyClick("cl_lnd_lt2_date_birth_year_choose");
  };

  return (
    <div className="promo__wrapper-birthday">
      <div className="user__form-top">
        <h3>My date of birth</h3>
      </div>
      <form className="form__date" onSubmit={handlerSubmit}>
        <div className="date__wrapper">
          <div className="date__wrapper-select aqa-test-month">
            <select
              className={`${data.month ? "active" : ""} ${
                errorDate ? "select__error" : ""
              }`}
              onChange={handleAddMonth}
              value={data.month || "default"}
            >
              <option value="default" disabled hidden>
                Month
              </option>
              {getMonths().map((item, index) => (
                <option key={index} value={index}>
                  {item || ""}
                </option>
              ))}
            </select>
          </div>
          <div className="date__wrapper-select aqa-test-day">
            <select
              className={`${data.day ? "active" : ""} ${
                errorDate ? "select__error" : ""
              }`}
              onChange={handleAddDay}
              value={data.day || "default"}
            >
              <option value="default" disabled hidden>
                Day
              </option>
              {getDate().map((item) => (
                <option key={item} value={item}>
                  {item || ""}
                </option>
              ))}
            </select>
          </div>
          <div className="date__wrapper-select aqa-test-year">
            <select
              className={`${data.year ? "active" : ""} ${
                errorDate ? "select__error" : ""
              }`}
              onChange={handleAddYear}
              value={data.year || "default"}
            >
              <option value="default" disabled hidden>
                Year
              </option>
              {getYears().map((item) => (
                <option key={item} value={item}>
                  {item || ""}
                </option>
              ))}
            </select>
          </div>
        </div>
        {errorDate && <p className="errorDate">{errorDate}</p>}
        <div className={"birthday_confirm"}>
          By proceeding, you confirm you are at least 18 years old and fully
          legally capable of using our website
        </div>
        <ButtonSubmit
          className={"button__global button__birthday"}
          text={"NEXT"}
        />
        <div className="progress__dots">
          <span className="active"></span>
          <span className="active"></span>
          <span className="active"></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </form>
    </div>
  );
}

export default BirthdayForm;